import React, { FC, SyntheticEvent, useState } from "react";
import ImageGallery, { ReactImageGalleryItem } from "react-image-gallery";
import ErrorImage from "../img/error-img.svg";
import "./Gallery.scss";

export interface GalleryImage {
    original: string;
    thumbnail: string;
    fullscreen?: string; // defaults to Original
}

interface GalleryProps {
    images: GalleryImage[];
}

export const Gallery: FC<GalleryProps> = (props) => {
    const [isFullscreen, setIsFullscreen] = useState(false);

    // workaround, to make fullscreen via css on iPhone, because fulscreenAPI is not working on iPhone
    const isIphone = navigator.userAgent.toLowerCase().indexOf("iphone") > -1;

    const setFullscreen = (fullscreen: boolean) => {
        if (isIphone) {
            const galleryNode = document.getElementsByClassName("image-gallery")[0];
            fullscreen ? galleryNode.classList.add("fullscreen-mode") : galleryNode.classList.remove("fullscreen-mode");
        }
        setIsFullscreen(fullscreen);
    };

    const handleImageError = (event: SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = ErrorImage;
    };

    const renderItem = (item: ReactImageGalleryItem) => {
        return (
            <>
                <img
                    className="image-gallery-image"
                    src={isFullscreen ? item.fullscreen : item.original}
                    onError={handleImageError}
                />
            </>
        );
    };

    return (
        <ImageGallery
            items={props.images}
            slideOnThumbnailOver={true}
            lazyLoad={true}
            showIndex={true}
            indexSeparator={" no "}
            additionalClass="results-image-gallery"
            renderItem={renderItem}
            onErrorImageURL={ErrorImage}
            onScreenChange={(fullscreen) => setFullscreen(!!fullscreen)}
            useBrowserFullscreen={!isIphone}
        />
    );
};
